import { LanguageService } from 'services/languageService';
import { AppDispatch } from 'store/index';
import { feedbackSlice } from 'store/reducers/feedback';
import { MainLangType } from 'types/mainPage';
import { httpClient } from 'utils/httpClient';

const URL = process.env.REACT_APP_API_URL;

export const setFeedbackNameAction =
  (name: string) => (dispatch: AppDispatch) => {
    dispatch(feedbackSlice.actions.setName(name));
  };

export const setFeedbackMailAction =
  (mail: string) => (dispatch: AppDispatch) => {
    dispatch(feedbackSlice.actions.setMail(mail));
  };

export const setFeedbackMessageAction =
  (message: string) => (dispatch: AppDispatch) => {
    dispatch(feedbackSlice.actions.setMessage(message));
  };

export const setOpenFeedbackModalAction =
  (open: boolean) => (dispatch: AppDispatch) => {
    dispatch(feedbackSlice.actions.setOpenModal(open));
  };

export const setOpenFeedbackInfoModalAction =
  (open: boolean) => (dispatch: AppDispatch) => {
    dispatch(feedbackSlice.actions.setOpenInfo(open));
  };

export const setOpenFeedbackWarningModalAction =
  (open: boolean) => (dispatch: AppDispatch) => {
    dispatch(feedbackSlice.actions.setOpenWarningModal(open));
  };

export const setConfirmFeedbackAction =
  (confirm: boolean) => (dispatch: AppDispatch) => {
    dispatch(feedbackSlice.actions.setConfirm(confirm));
  };

export const setMainPageLangAction =
  (lang: MainLangType) => (dispatch: AppDispatch) => {
    dispatch(feedbackSlice.actions.setLang(lang));
  };

export const resetFeedbackAction = () => (dispatch: AppDispatch) => {
  dispatch(feedbackSlice.actions.resetFeedback());
};

export const submitFeedbackFormAction =
  (name: string, email: string, message: string) =>
  async (dispatch: AppDispatch) => {
    const lang = LanguageService.getLanguage();

    try {
      const url = `${URL}/api/feedback`;
      const res = await httpClient.post(url, {
        name,
        email,
        message,
      });

      const _select = res.data.data;

      dispatch(feedbackSlice.actions.setConfirm(true));
    } catch (e) {
      console.log(e);
    } finally {
      dispatch(feedbackSlice.actions.setConfirm(false));
    }
  };

export const getTextForFeedback =
  (infoLang: string) => async (dispatch: AppDispatch) => {
    try {
      const url = `${URL}/api/feedbacktext`;
      const res = await httpClient.post(url, {
        lang: infoLang,
      });

      const _select = res.data.data;

      dispatch(feedbackSlice.actions.setFeedbackText(_select.value));
    } catch (e) {
      console.log(e);
      dispatch(feedbackSlice.actions.setFeedbackText(''));
    }
  };
